import { Trans } from "adapters/i18n";
import React, { type CSSProperties } from "react";
import type { PortalNews } from "shared/types";
import { PortalRoutes } from "./routes";

const highlightStyles: CSSProperties = {
  color: "#307297",
  fontWeight: "bold",
};

const headerStyles: CSSProperties = {
  ...highlightStyles,
  textAlign: "center",
};

export const portalNews: PortalNews[] = [
  {
    id: "ALTERACOES_BALANCO_ARROBA",
    message: (
      <Trans
        i18nKey="news:arroba-balance-changes.message"
        components={{ bold: <strong />, p: <p /> }}
      />
    ),
    minDate: "2025-02-20",
    maxDate: "2025-02-28",
    repeat: "no-repeat",
    title: <Trans i18nKey="news:we-have-news" />,
  },
  {
    id: "PERMITIR_ADMINISTRADOR_CRIAR_USUARIO",
    message: (
      <Trans
        i18nKey="news:allow-admin-create-user.message"
        components={{
          // eslint-disable-next-line jsx-a11y/heading-has-content
          header: <h3 style={headerStyles} />,
          p: <p />,
          highlight: <span style={highlightStyles} />,
        }}
      />
    ),
    minDate: "2024-07-02",
    maxDate: "2024-08-02",
    repeat: "no-repeat",
    title: <Trans i18nKey="news:we-have-news" />,
  },
  {
    id: "LIBERACAO_PENDENCIAS",
    message: (
      <Trans
        i18nKey="news:pending-movements-improvement.message"
        components={{
          // eslint-disable-next-line jsx-a11y/heading-has-content
          header: <h3 style={headerStyles} />,
          p: <p />,
          highlight: <span style={highlightStyles} />,
        }}
      />
    ),
    minDate: "2024-07-08",
    maxDate: "2024-07-20",
    repeat: "no-repeat",
    title: <Trans i18nKey="news:we-have-news" />,
  },
  {
    id: "LIBERACAO_CENTRAL_AJUDA",
    message: (
      <Trans
        i18nKey="news:help-center-release.message"
        components={{
          // eslint-disable-next-line jsx-a11y/heading-has-content
          header: <h3 style={headerStyles} />,
          p: <p />,
          highlight: <span style={highlightStyles} />,
        }}
      />
    ),
    minDate: "2024-03-06",
    maxDate: "2024-04-06",
    repeat: "no-repeat",
    title: <Trans i18nKey="news:we-have-news" />,
  },
  {
    id: "NOVA_VISUALIZACAO_ALTURA_DE_FORRAGEM",
    message: (
      <Trans
        i18nKey="news:forage-height.message"
        components={{
          // eslint-disable-next-line jsx-a11y/heading-has-content
          header: <h3 style={headerStyles} />,
          p: <p />,
          highlight: <span style={highlightStyles} />,
        }}
      />
    ),
    minDate: "2024-02-26",
    maxDate: "2024-03-26",
    repeat: "no-repeat",
    title: <Trans i18nKey="news:we-have-news" />,
  },
  {
    id: "MANUTENCAO_PROGRAMADA_REBANHO_2",
    message: (
      <Trans
        i18nKey="news:scheduled-herd-maintenance-2.message"
        components={{
          p: <p />,
          highlight: <span style={highlightStyles} />,
        }}
      />
    ),
    minDate: "2023-12-04",
    maxDate: "2023-12-05",
    repeat: "no-repeat",
    title: <Trans i18nKey="news:we-have-news" />,
    showImage: false,
  },
  {
    id: "MANUTENCAO_PROGRAMADA_REBANHO_3",
    message: (
      <Trans
        i18nKey="news:scheduled-herd-maintenance-3.message"
        components={{
          p: <p />,
          highlight: <span style={highlightStyles} />,
        }}
      />
    ),
    minDate: "2023-12-05",
    maxDate: "2023-12-06",
    repeat: "no-repeat",
    title: <Trans i18nKey="news:we-have-news" />,
    showImage: false,
  },
  {
    id: "ALTERACAO_DE_MARCA",
    message: (
      <Trans
        i18nKey="news:brand-change.message"
        components={{
          bold: <strong />,
          // eslint-disable-next-line jsx-a11y/heading-has-content
          header: <h3 style={headerStyles} />,
          highlight: <span style={highlightStyles} />,
          p: <p />,
        }}
      />
    ),
    minDate: "2023-10-22",
    maxDate: "2023-10-27",
    repeat: "no-repeat",
    title: <Trans i18nKey="news:we-have-news" />,
    showImage: true,
  },
  {
    id: "MANUTENCAO_PROGRAMADA_REBANHO",
    message: (
      <Trans
        i18nKey="news:scheduled-herd-maintenance.message"
        components={{
          highlight: <span style={highlightStyles} />,
          p: <p />,
        }}
      />
    ),
    minDate: "2023-10-15",
    maxDate: "2023-10-18",
    repeat: "no-repeat",
    title: <Trans i18nKey="news:important-notice" />,
    showImage: false,
  },
  {
    id: "EPICO_SUPLEMENTACAO",
    message: <Trans i18nKey="news:supplementation-release.message" />,
    link: PortalRoutes.COLLECT_SUPPLEMENTATION,
    minDate: "2022-09-21",
    maxDate: "2022-10-22",
    repeat: "no-repeat",
  },
  {
    id: "BLOQUEIO_COLETAS_DATA_HORA",
    message: (
      <Trans
        i18nKey="news:block-sync-for-different-timezone.message"
        components={{
          highlight: <span style={highlightStyles} />,
          p: <p />,
        }}
      />
    ),
    minDate: "2022-10-21",
    maxDate: "2022-12-24",
    repeat: "no-repeat",
  },
  {
    id: "NOVO_CADASTRO_FAZENDA",
    message: (
      <Trans
        i18nKey="news:farm-creation-change.message"
        components={{
          highlight: <span style={highlightStyles} />,
        }}
      />
    ),
    minDate: "2023-02-13",
    maxDate: "2023-03-20",
    repeat: "no-repeat",
  },
  {
    id: "EPICO_RESOLUCAO_DE_PENDENCIA",
    message: (
      <Trans
        i18nKey="news:pending-movements-resolution-release.message"
        components={{
          emoji: <span role="img" />,
          highlight: <span style={highlightStyles} />,
          p: <p />,
        }}
      />
    ),
    minDate: "2024-09-25",
    maxDate: "2024-10-26",
    repeat: "no-repeat",
    title: <Trans i18nKey="news:important-notice" />,
  },
  {
    id: "UPDATE_APP_ANDROID",
    message: (
      <Trans
        i18nKey="news:android-app-update.message"
        components={{ p: <p />, bold: <strong /> }}
      />
    ),
    minDate: "2025-09-30",
    maxDate: "2025-10-31",
    repeat: "daily",
    title: <Trans i18nKey="news:android-app-update.title" />,
  },
  {
    id: "MAINTENANCE-26-06-01",
    message: (
      <Trans
        i18nKey="news:maintenance-26-06-01.message"
        components={{
          p: <p />,
          bold: <strong />,
          highlight: <span style={highlightStyles} />,
        }}
      />
    ),
    showImage: false,
    minDate: "2026-06-01",
    maxDate: "2026-06-01",
    repeat: "daily",
    title: <Trans i18nKey="news:maintenance-26-06-01.title" />,
  },
];
